import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated, setAuthCookie } from '~/lib/auth';

export default function AuthGuard() {
  const location = useLocation();
  const [hashChecked, setHashChecked] = useState(false);

  // Embed contexts (e.g. SoluAgro inside web-bot-client) pass the parent's
  // access token via URL hash because cross-origin iframes have partitioned
  // storage and can't reuse a top-level OIDC session.
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('accessToken=')) {
      const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
      const token = params.get('accessToken');
      if (token) {
        setAuthCookie(token);
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }
    setHashChecked(true);
  }, []);

  if (!hashChecked) return null;
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ returnTo: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
